import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';

export interface ErrorDialogProps {
  open: boolean;
  onClose: () => void;
  error: any;
  title?: string;
}

const ErrorDialog = ({ open, onClose, error, title = "Error" }: ErrorDialogProps) => {
  
  // Parse error and extract error message
  const parseErrorMessage = (error: any): string => {
    if (!error) return 'An unknown error occurred.';

    // If error is wrapped in { children: ... }
    if (error.children && typeof error.children === 'object') {
      error = error.children;
    }

    // String error
    if (typeof error === 'string') return error;

    // normal Error object
    if (error instanceof Error) return error.message;

    // Laravel-style: { field: [msg, ...], ... }
    if (typeof error === 'object') {
      const messages: string[] = [];
      Object.values(error).forEach((val) => {
        if (Array.isArray(val)) {
          messages.push(...val);
        } else if (typeof val === 'string') {
          messages.push(val);
        }
      });
      if (messages.length) return messages.join('\n');
    }

    return 'An error occurred. Please try again.';
  };

  const errorMessage = parseErrorMessage(error);

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Alert severity="error" sx={{ whiteSpace: 'pre-line' }}>
          {errorMessage}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorDialog;
